import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import PromoBanner from "@/components/PromoBanner";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Tools from "@/pages/Tools";
import Jobs from "@/pages/Jobs";
import Events from "@/pages/Events";
import News from "@/pages/News";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Admin from "@/pages/Admin";
import PaymentReturn from "@/pages/PaymentReturn";
import ToolDetail from "@/pages/ToolDetail";
import JobDetail from "@/pages/JobDetail";
import CompanyProfile from "@/pages/CompanyProfile";
import Compare from "@/pages/Compare";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import Cookies from "@/pages/Cookies";
import Disclaimer from "@/pages/Disclaimer";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Courses from "@/pages/Courses";
import Recruiters from "@/pages/Recruiters";
import RecruiterSuccess from "@/pages/RecruiterSuccess";
import Advertise from "@/pages/Advertise";
import Sources from "@/pages/Sources";
import AIinYourJob from "@/pages/AIinYourJob";
import AIHuman from "@/pages/AIHuman";
import AIProgress from "@/pages/AIProgress";
import AIDataHub from "@/pages/AIDataHub";
import DataItemDetail from "@/pages/DataItemDetail";
import SideHustles from "@/pages/SideHustles";
import Papers from "@/pages/Papers";
import CookieConsent from "@/components/CookieConsent";
import AIAssistant from "@/components/assistant/AIAssistant";

const Protected = ({ children, admin }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-[#94A3B8]">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (admin && user.role !== "admin") return <Navigate to="/dashboard" replace />;
  return children;
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster theme="dark" position="top-right" richColors />
          <Navbar />
          <PromoBanner />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/tools" element={<Tools />} />
            <Route path="/tools/:id" element={<ToolDetail />} />
            <Route path="/compare" element={<Compare />} />
            <Route path="/jobs" element={<Jobs />} />
            <Route path="/jobs/:id" element={<JobDetail />} />
            <Route path="/company/:id" element={<CompanyProfile />} />
            <Route path="/events" element={<Events />} />
            <Route path="/news" element={<News />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
            <Route path="/admin" element={<Protected admin><Admin /></Protected>} />
            <Route path="/payment-return" element={<PaymentReturn />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/cookies" element={<Cookies />} />
            <Route path="/disclaimer" element={<Disclaimer />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/courses" element={<Courses />} />
            <Route path="/recruiters" element={<Recruiters />} />
            <Route path="/recruiters/success" element={<RecruiterSuccess />} />
            <Route path="/advertise" element={<Advertise />} />
            <Route path="/sources" element={<Sources />} />
            <Route path="/ai-in-your-job" element={<AIinYourJob />} />
            <Route path="/ai-human" element={<AIHuman />} />
            <Route path="/ai-progress" element={<AIDataHub />} />
            <Route path="/data/:id" element={<DataItemDetail />} />
            <Route path="/side-hustles" element={<SideHustles />} />
            <Route path="/papers" element={<Papers />} />
          </Routes>
          <Footer />
          <CookieConsent />
          <AIAssistant />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
